<template>
  <v-dialog
    :value="value"
    max-width="880"
    @input="$emit('input', $event)"
  >
    <v-card v-if="episode">
      <v-card-title class="d-flex align-center flex-nowrap">
        <span class="text-h6 text-truncate">{{ episode.title }}</span>
        <v-spacer />
        <v-btn
          icon
          data-qa="advisor-podcast-player-close"
          @click="$emit('input', false)"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-responsive :aspect-ratio="16 / 9">
        <iframe
          v-if="value && playerUrl"
          :src="playerUrl"
          class="podcast-player-frame"
          allow="autoplay; fullscreen"
          allowfullscreen
          frameborder="0"
          data-qa="advisor-podcast-player-iframe"
        />
      </v-responsive>

      <v-card-text class="pt-3">
        <div
          class="text-caption grey--text"
          data-qa="advisor-podcast-player-meta"
        >
          <template v-if="episode.published_at">
            <span>Published {{ formatDate(episode.published_at) }}</span>
            <span class="mx-1">·</span>
          </template>
          <span v-if="episode.duration_seconds">
            {{ formatVideoDuration(episode.duration_seconds) }}
          </span>
        </div>
        <p
          v-if="episode.description"
          class="text-body-2 mt-2 mb-0"
        >
          {{ episode.description }}
        </p>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { trackPodcastView } from '@/api/ibModule';
import { formatDate, formatVideoDuration } from '@/helpers/formatting';

export default {
  name: 'AdvisorPodcastPlayerDialog',

  props: {
    value: {
      type: Boolean,
      default: false,
    },
    episode: {
      type: Object,
      default: null,
    },
  },

  computed: {
    playerUrl() {
      if (!this.episode.wistia_hashed_id) {
        return null;
      }
      return `https://fast.wistia.net/embed/iframe/${this.episode.wistia_hashed_id}?autoPlay=true`;
    },
  },

  watch: {
    value: {
      immediate: true,
      handler(open) {
        if (open && this.episode) {
          // Fire-and-forget: the backend decides whether the play counts
          // (owner previews and drafts never do), so failures stay silent.
          trackPodcastView({ episode_id: this.episode.id }).catch(() => {});
        }
      },
    },
  },

  methods: {
    formatDate,
    formatVideoDuration,
  },
};
</script>

<style scoped>
.podcast-player-frame {
  display: block;
  width: 100%;
  height: 100%;
}
</style>
